import { httpClient } from '@/infra/protocols/http';
import { IUserDTO } from '@/modules/auth/dtos/user.dto';
import { IUser } from '@/modules/auth/entities/user.entity';
import { UserMapper } from '@/modules/auth/mappers/user.mapper';
import { IMemberDTO } from '@/modules/members/dtos/member.dto';
import { IMember } from '@/modules/members/entities/member.entity';

export async function getProjectAccess(
  params: GetProjectAccessService.Params,
): Promise<GetProjectAccessService.Response> {
  const response = await httpClient.get<{
    membros: IMemberDTO[];
    solicitacoes: { id: number; usuario: IUserDTO }[];
  }>(`/v1/projetos/${params.projectId}/membros-solicitacoes`);

  return {
    members: response.membros.map((member) => ({
      id: member.id,
      name: member.nome,
      email: member.email,
      joinedAt: member.entrouEm,
      expiresAt: member.expiraEm,
      lastName: member.sobrenome,
      avatarUrl: member.avatarUrl,
      fullName: `${member.nome} ${member.sobrenome}`,
      role: {
        id: member.cargo.id,
        name: member.cargo.nome,
      },
    })),
    requests: response.solicitacoes.map((solicitacao) => ({
      id: solicitacao.id,
      user: UserMapper.toPresentation(solicitacao.usuario),
    })),
  };
}

export namespace GetProjectAccessService {
  export interface Params {
    projectId: string;
  }

  export type Response = {
    members: IMember[];
    requests: { id: number; user: IUser }[];
  };
}
